import { IconMap, theme } from 'aimo-ui';
import React from 'react';
import { View } from 'react-native';
import { IconTypes, SizeProps } from 'types/IconTypes';
import IconIndicator from './IconIndicator';

const sizes: SizeProps = theme.iconSizes;

const EmptyIcon = () => <></>;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Icon = ({
  name,
  size = 'm',
  color = theme.colors.black,
  strokeColor,
  testID,
  indicatorType,
  indicatorNumber,
  ...rest
}: IconTypes) => {
  const numericSize = typeof size === 'number' ? size : sizes[size];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore-next-line, because we generate js files
  const ReturnedIcon = IconMap[name] || EmptyIcon;
  const IconItem = (
    <ReturnedIcon
      fill={color}
      width={numericSize}
      height={numericSize}
      testID={testID}
      stroke={strokeColor}
      {...rest}
    />
  );

  if (indicatorType) {
    return (
      <View>
        {IconItem}
        <IconIndicator
          indicatorNumber={indicatorNumber}
          indicatorType={indicatorType}
          testID={testID}
        />
      </View>
    );
  }

  return IconItem;
};

export default Icon;
